module.exports = __webpack_public_path__ + "img/logo-white-sm.f2fd77fa.png";